<template>
    <div class="list-page__items" >
        <h2 v-if="props.heading">
            {{props.heading}}
        </h2>
        <div class="row" v-if="props.serviceitems.length">
            <TransitionGroup name="list"
                             @before-enter="onBeforeEnter"
                             @enter="onEnter"
                             :css="false"
                             @leave="onLeave">
                <div v-for="(item, index) in props.serviceitems"
                     :key="item.id"
                     :data-index="index"
                     class="col-12 col-md-6 col-lg-4 list-page__item-container">
                    <ServiceItem v-if="item.listItemType === 0" :item="item"></ServiceItem>
                    <ConnectedItem v-if="item.listItemType === 1" :item="item"></ConnectedItem>
                </div>
            </TransitionGroup>
        </div>
    </div>
</template>
<script setup>
    import { onMounted, onUnmounted, reactive } from 'vue';
    import { gsap } from 'gsap';
    import ServiceItem from './_serviceitem.vue';
    import ConnectedItem from './_connecteditem.vue';

    const pageSizeSM = 2;
    const pageSizeMD = 5;
    const pageSize = 8;

    const props = defineProps({
       heading: {
            default: null,
            type: String
        },
        serviceitems: {
            default: [],
            type: Array
        }
    })

    const state = reactive({
        animationDelay: 0.5,
    });

    const showAll = () => {
        state.showAll = true;
    }

    const onBeforeEnter = (el, done) => {
        gsap.to(el, {
            duration: 0,
            alpha: 0
        })
    }

    const onEnter = (el, done) => {
        let index = el.dataset.index;
        let delay = index >= state.currentBreakpoint.pageSize ? (index - state.currentBreakpoint.pageSize) * 0.15 : index * 0.15;
        gsap.to(el, {
            alpha: 1,
            duration: 2,
            x: 0,
            onComplete: done,
            delay: delay
        })
    }

    const onLeave = (el, done) => {
        gsap.to(el, {
            duration: 0.3,
            alpha: 0,
            onComplete: done
        })
    }




    onMounted(() => {

    });

    onUnmounted(() => {

    })

</script>
